import { Mutation } from "../types";

export default {
  [Mutation.SET_GROUP_PROFILE](state: any, payload: any) {
    state.groupProfile = payload;
  },
  [Mutation.SET_GROUP_PROFILES](state: any, payload: any) {
    state.groupProfile = payload;
  },
  [Mutation.SET_INVITED_GROUP](state: any, payload: string) {
    state.invitedGroup = payload;
  },
};
